import React, { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { filter, get } from 'lodash';
import { RootState } from 'modules';
import { useRecoilState } from 'recoil';
import { HeaderHeight } from 'components/base/styles';
import { getQNAAccessUser } from 'libs/api/mentoring';
import { QNABtnUserListState } from 'modules/mentoring/recoilState';
import { TUser } from 'modules/user';
import { CInstagramURL, CKakaoTalkURL, CNotionFAQURL, CYoutubeURL } from 'constants/base.const';
import { EUserType } from 'enums/base.enum';
import { EMentoringField } from 'enums/mentoring.enum';
import { ERoute } from 'enums/route.enum';
import { Menu, Tooltip, Typography } from 'antd';
import styled from 'styled-components';
import { Colors, device, menubarBreakPoint } from 'GlobalStyles';
import { ReactComponent as InstagramSource } from 'assets/icons/instagram.svg';
import { ReactComponent as KakaoSource } from 'assets/icons/kakao-talk.svg';
import { ReactComponent as YoutubeSVGSource } from 'assets/images/logos/youtube2.svg';

type TMenuProps = {
  mode: 'horizontal' | 'inline';
  onClick?: () => void;
};

const { SubMenu } = Menu;
const { Text } = Typography;

const menuNames = [
  {
    name: '1:1 멘토링',
    path: 'mentoring',
    children: [
      { name: '전체 멘토 보기', path: 'mentor_list' },
      { name: '나의 멘토링 관리', path: 'my_page' },
      { name: '나의 멘티 보기', path: 'my_mentee' },
      {
        name: '멘토 상세',
        path: 'mentor_view',
        children: [{ name: '멘토링 신청', path: 'class_create' }],
      },
      { name: '멘토링 방식 소개', path: 'about' },
      { name: '수업 상세', path: 'class_view' },
      {
        name: '피드백',
        path: 'feedback',
        children: [
          { name: '쓰기', path: 'create' },
          { name: '보기', path: 'view' },
          { name: '수정', path: 'edit' },
        ],
      },
      { name: '수강권 구매', path: 'credit_price' },
      { name: '결제', path: 'credit_purchase' },
      { name: '결제 완료', path: 'credit_purchase_completed' },
      { name: '프로그램 소개', path: 'program_about' },
      { name: 'Q&A ', path: 'qna' },
      { name: '대시보드', path: 'dashboard' },
    ],
  },
  {
    name: '셀프 학습',
    path: 'case',
    children: [
      { name: '케이스 노트', path: 'introduction' },
      { name: '케이스 노트', path: 'board' },
      // { name: "Q&A ", path: "qna" },
      { name: 'Case 기출 라이브러리', path: 'library' },
      { name: '인터뷰 가이드', path: 'framework' },
      { name: '케이스 문제', path: 'quizzes' },
    ],
  },
  {
    name: '내정보',
    path: 'user',
    children: [
      { name: '수정하기', path: 'edit' },
      { name: '마이페이지', path: 'credit' },
      //멘토 전환하기 추가
      { name: '멘토 전환하기', path: 'switch_to_mentor' },
      { name: '정산하기', path: 'credit_exchange' },
      { name: '정산신청', path: 'credit_exchange_request' },
      { name: '로그인', path: 'login', visible: false },
      { path: 'password_reset', visible: false },
    ],
  },
  {
    name: '채용공고',
    path: 'company',
    children: [
      { name: '채용공고 등록', path: 'job_opening' },
      {
        name: '경력직 공고',
        path: 'turnover',
        children: [{ name: '보기', path: 'view' }],
      },
      {
        name: '정규직 공고',
        path: 'fulltime',
        children: [{ name: '보기', path: 'view' }],
      },
      {
        name: '인턴 공고',
        path: 'parttime',
        children: [{ name: '보기', path: 'view' }],
      },
      // { name: "회사 탐색", path: "search" },
    ],
  },
  {
    name: '문의하기',
    path: 'introduction',
    children: [
      { name: '서비스 소개', path: 'landing' },
      { name: '공지사항', path: 'announcement' },
      { name: '자주묻는 질문', path: 'question' },
      { name: '1:1 상담하기', path: 'customer_inquiry' },
      { name: '환불규졍', path: '' },
    ],
  },
  {
    name: '인터뷰 후기',
    path: 'cslab',
    children: [
      //멘토 멘티 (CS 기획 content -> cs 뉴스)
      { name: 'CS 뉴스', path: 'board' },
      //멘토 멘티
      { name: 'CS 웨비나', path: 'webinar' },
      //멘토 멘티
      { name: '회사 탐색', path: 'search' },
      //멘토 멘티
      { name: '멘토 Finder', path: 'mentor_finder' },
      //멘티
      // { name: "멘토 전환하기", path: "switch_to_mentor" },
      { name: '인턴 보기', path: 'intern_view' },
      //멘토
      // { name: "My Intern Finder", path: "intern_finder" },
      //엑셀 강의 리스트
      { name: '엑셀 강의', path: 'excel_class_list' },
      //엑셀 강의 영상 페이지 에서 Breadcrumb에 엑셀 강의 영상 텍스트 뜰 수 있도록
      { name: '엑셀 강의 영상', path: 'excel_class_player' },
    ],
  },
  {
    name: '커뮤니티',
    path: 'community',
    children: [
      { name: '인터뷰 후기', path: 'interview_review' },
      { name: '최종 합격 후기', path: 'final_acceptance' },
    ],
  },
];

export function getMenuTitle(route: string) {
  /* route url의 경로 이름들의 list를 반환 */
  const pathList = filter(route.split('/'), (x) => isNaN(Number(x)));
  let pathNameList = [] as string[];
  let currentMenu: any = filter(menuNames, (x) => x.path == pathList[0])[0];
  let index = 0;
  let visible = true;

  for (; index < pathList.length; index++) {
    const pathName = get(currentMenu, 'name');

    if (get(currentMenu, 'visible', true) === false) visible = false;

    if (pathName) {
      pathNameList.push(pathName);
    }
    currentMenu = filter(get(currentMenu, 'children'), (x) => x.path == pathList[index + 1])[0];
  }

  if (visible === true) return pathNameList;

  return [];
}

export const mentoringMenuTitle = (currentUser?: TUser) => {
  //로그인 전 ==> 로그인 전에도 풀어줘야하기 때문에 APP 에서도 권한 풀어주기
  if (!currentUser) {
    return (
      <Link to={ERoute.MentoringMentorList}>
        <div className='submenu-title'>{getMenuTitle('/mentoring')[0]}</div>
      </Link>
    );
  } else {
    //로그인 후
    if (currentUser?.user_type === EUserType.Mentee) {
      return (
        <Link to={ERoute.MentoringMentorList}>
          <div className='submenu-title'>{getMenuTitle('/mentoring')[0]}</div>
        </Link>
      );
    } else {
      return (
        <Link to={ERoute.MentoringMyPage}>
          <div className='submenu-title'>{getMenuTitle('/mentoring')[0]}</div>
        </Link>
      );
    }
  }
};
export const companyMenuTitle = (currentUser?: TUser) => {
  if (!currentUser) {
    return (
      //멘티 - 채용 공고 메뉴 클릭 시 정규직 공고를 기본 페이지로
      <Link to={ERoute.CompanyFulltime}>
        <div className='submenu-title'>{getMenuTitle(ERoute.CompanyFulltime)[0]}</div>
      </Link>
    );
  } else {
    if (currentUser?.user_type === EUserType.Mentee) {
      return (
        //멘티 - 채용 공고 메뉴 클릭 시 정규직 공고를 기본 페이지로
        <Link to={ERoute.CompanyFulltime}>
          <div className='submenu-title'>{getMenuTitle(ERoute.CompanyFulltime)[0]}</div>
        </Link>
      );
    } else {
      return (
        //멘토 - 채용 공고 메뉴 클릭 시 경력직 공고를 기본 페이지로
        <Link to={ERoute.CompanyTurnOver}>
          <div className='submenu-title'>{getMenuTitle(ERoute.CompanyTurnOver)[0]}</div>
        </Link>
      );
    }
  }
};

export const introductionMenuTitle = () => (
  <div>
    <a style={{ color: 'black' }} target='_blank' rel='noopener noreferrer' href={CNotionFAQURL}>
      FAQ
    </a>
  </div>
  //  <Link to={ERoute.IntroductionCustomerInquiry}>
  //  <div className='submenu-title'>{getMenuTitle(ERoute.IntroductionAnnouncement)[0]}</div>
  //  </Link>
);

export const CSLabMenuTitle = () => (
  <Link to={ERoute.ExcelClassList}>
    <div className='submenu-title'>{getMenuTitle(ERoute.ExcelClassList)[0]}</div>
  </Link>
);

export const caseMenuTitle = (user?: TUser) => {
  if (user?.primary_field === EMentoringField.Finance) {
    return (
      <Link to={ERoute.CSLearningBoard}>
        <div className='submenu-title'>Contents</div>
      </Link>
    );
  } else {
    return (
      <Link to={ERoute.CSLearningBoard}>
        <div className='submenu-title'>{getMenuTitle(ERoute.CSLearningBoard)[0]}</div>
      </Link>
    );
  }
};

export const learningMenuTitle = (currentUser: TUser) => (
  <Link to={ERoute.CSLearningBoard}>
    <div className='submenu-title'>{getMenuTitle(ERoute.CSLearningBoard)[0]}</div>
  </Link>
);

export const communityMenuTitle = () => (
  <Link to={ERoute.InterviewReviewBoard}>
    <div className='submenu-title'>{getMenuTitle(ERoute.InterviewReviewBoard)[0]}</div>
  </Link>
);

export const HeaderLeft = ({ mode, onClick }: TMenuProps) => {
  const location = useLocation();
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  const [QNABtnUserList, setQNABtnUserList] = useRecoilState<any>(QNABtnUserListState);

  const getQNAAccessUserList = async () => {
    const { data } = await getQNAAccessUser();
    const userList = data.map((el: { userid: string }) => el.userid);
    setQNABtnUserList(userList);
  };

  useEffect(() => {
    getQNAAccessUserList();
  }, []);

  return (
    <HeaderLeftWrapper>
      {currentUser ? (
        <StyledMenubarWrapper
          style={{
            justifyContent: `${mode !== 'inline' && 'space-around'}`,
          }}
        >
          <Menu
            //햄버거 메뉴일 때는 mode가 inline인데 이 때는 height 70px 먹지 않도록
            style={{
              height: `${mode !== 'inline' && HeaderHeight}px`,
              width: `${mode !== 'inline' && '100%'}`,
            }}
            // style={{ height: `${HeaderHeight}px` }}
            selectedKeys={[location.pathname]}
            mode={mode}
            onClick={onClick}
          >
            <SubMenu
              title={
                <Link to={`${ERoute.MentoringProgramAbout}`}>
                  <div className='submenu-title'>프로그램 소개</div>
                </Link>
              }
            >
              {/* <Menu.Item key={`${ERoute.MentoringProgramAbout}?field=${EMentoringField.Consulting}`}>
                <Link to={`${ERoute.MentoringProgramAbout}?field=${EMentoringField.Consulting}`}>
                  Consulting
                </Link>
              </Menu.Item>
              <Menu.Item key={`${ERoute.MentoringProgramAbout}?field=${EMentoringField.Finance}`}>
                <Link to={`${ERoute.MentoringProgramAbout}?field=${EMentoringField.Finance}`}>Finance</Link>
              </Menu.Item>
              <Menu.Item key={`${ERoute.MentoringProgramAbout}?field=${EMentoringField.Tech}`}>
                <Link to={`${ERoute.MentoringProgramAbout}?field=${EMentoringField.Tech}`}>Tech</Link>
              </Menu.Item> */}
              {/* <Menu.Item key={ERoute.CaseIntroduction}>
              <Link to={ERoute.CaseIntroduction}>
                {getMenuTitle(ERoute.CaseIntroduction)[1]}
              </Link>
            </Menu.Item> */}
            </SubMenu>
            {/* 📍 케이스 스터디 */}
            <SubMenu title={caseMenuTitle(currentUser)}>
              {/* framework */}
              <Menu.Item key={ERoute.CSLearningBoard}>
                <Link to={ERoute.CSLearningBoard}>{getMenuTitle(ERoute.CSLearningBoard)[1]}</Link>
              </Menu.Item>

              <Menu.Item key={ERoute.CSLearningBoard}>
                <Link to={ERoute.LectureInterviewMasterClassBasic}>기초편 온라인 강의</Link>
              </Menu.Item>
              {/* quizzes */}
              {currentUser.primary_field !== EMentoringField.Finance && (
                <Menu.Item key={ERoute.CSLearningQuizList}>
                  <Link to={ERoute.CSLearningQuizList}>{getMenuTitle(ERoute.CSLearningQuizList)[1]}</Link>
                </Menu.Item>
              )}

              {/* 케이스 노트 소개 */}
              {currentUser.primary_field !== EMentoringField.Finance && (
                <Menu.Item key={ERoute.CaseIntroduction}>
                  <Link to={ERoute.CaseIntroduction}>{getMenuTitle(ERoute.CaseIntroduction)[1]}</Link>
                </Menu.Item>
              )}

              <Menu.Item key={ERoute.ExcelClassList}>
                <Link to={ERoute.ExcelClassList}>{getMenuTitle(ERoute.ExcelClassList)[1]}</Link>
              </Menu.Item>
              {/* 케이스 노트 리스트 페이지 */}
              {/* <Menu.Item key={ERoute.CaseBoard}>
                <Link to={ERoute.CaseBoard}>
                  {getMenuTitle(ERoute.CaseBoard)[1]}
                </Link>
              </Menu.Item> */}
            </SubMenu>

            {/* 📍 1:1멘토링 */}
            {currentUser.is_verified === true ? (
              <SubMenu title={mentoringMenuTitle(currentUser)}>
                {/* 멘티일 때 전체 멘토보기 */}
                <Menu.Item key={ERoute.MentoringMentorList}>
                  <Link to={ERoute.MentoringMentorList}>{getMenuTitle(ERoute.MentoringMentorList)[1]}</Link>
                </Menu.Item>
                {/* 멘티 & 멘토 - 나의 멘토링 관리*/}
                <Menu.Item key={ERoute.MentoringMyPage}>
                  <Link to={ERoute.MentoringMyPage}>{getMenuTitle(ERoute.MentoringMyPage)[1]}</Link>
                </Menu.Item>
                {/* 대시보드 */}
                {currentUser?.user_type === EUserType.Mentee &&
                  currentUser.primary_field !== EMentoringField.Finance && (
                    <Menu.Item key={ERoute.MentoringDashboard}>
                      <Link to={ERoute.MentoringDashboard}>{getMenuTitle(ERoute.MentoringDashboard)[1]}</Link>
                    </Menu.Item>
                  )}
                {/* QNA */}
                {/* 정규반 리스트만 Q&A 게시판 확인 가능하도록 */}
                {/* {QNABtnUserList?.includes(currentUser?.userid) && (
                  <Menu.Item key={ERoute.MentoringQNA}>
                    <Link to={ERoute.MentoringQNA}>{getMenuTitle(ERoute.MentoringQNA)[1]}</Link>
                  </Menu.Item>
                )} */}

                {/* 멘토일 때 - 나의 멘티 보기*/}
                {/* {currentUser?.user_type === EUserType.Mentor && (
                <Menu.Item key={ERoute.MentoringMyMentee}>
                  <Link to={ERoute.MentoringMyMentee}>
                    {getMenuTitle(ERoute.MentoringMyMentee)[1]}
                  </Link>
                </Menu.Item>
              )} */}
                {/* 멘토링 방식 소개 */}
                {/* <Menu.Item key={ERoute.MentoringAbout}>
                <Link to={ERoute.MentoringAbout}>
                  {getMenuTitle(ERoute.MentoringAbout)[1]}
                </Link>
              </Menu.Item> */}
                {/* 멘토링 프로그램 소개 */}
                {/* {currentUser?.user_type === EUserType.Mentee && (
                <Menu.Item key={ERoute.MentoringProgramAbout}>
                  <Link to={ERoute.MentoringProgramAbout}>
                    {getMenuTitle(ERoute.MentoringProgramAbout)[1]}
                  </Link>
                </Menu.Item>
              )} */}
                {/* 멘토일 때 전체 멘토 보기 */}
                {/* {currentUser?.user_type === EUserType.Mentor && (
                <Menu.Item key={ERoute.MentoringMentorList}>
                  <Link to={ERoute.MentoringMentorList}>
                    {getMenuTitle(ERoute.MentoringMentorList)[1]}
                  </Link>
                </Menu.Item>
              )} */}

                {/* {currentUser?.user_type === EUserType.Mentee && (
                <Menu.Item key={ERoute.MentoringDashboard}>
                  <Link to={ERoute.MentoringDashboard}>
                    {getMenuTitle(ERoute.MentoringDashboard)[1]}
                  </Link>
                </Menu.Item>
              )} */}
              </SubMenu>
            ) : (
              <SubMenu
                title={
                  <Tooltip
                    title={
                      <>
                        <div>전/현직 인증 필요</div>
                        <div>
                          <Link style={{ color: '#fff' }} to={ERoute.MentorVerification}>
                            재인증 요청하기
                          </Link>
                        </div>
                      </>
                    }
                  >
                    <span style={{ color: '#aeaeae' }}>{getMenuTitle('/mentoring')[0]}</span>
                  </Tooltip>
                }
              ></SubMenu>
            )}
            {/* 📍 커뮤니티 */}
            <SubMenu title={CSLabMenuTitle()}>
              {/* 인터뷰 후기 */}
              <Menu.Item key={ERoute.InterviewReviewBoard}>
                <Link to={ERoute.InterviewReviewBoard}>{getMenuTitle(ERoute.InterviewReviewBoard)[1]}</Link>
              </Menu.Item>
              {/* 최종 합격 후기 */}
              {currentUser.primary_field !== EMentoringField.Finance && (
                <Menu.Item key={ERoute.FinalAcceptanceBoard}>
                  <Link to={ERoute.FinalAcceptanceBoard}>{getMenuTitle(ERoute.FinalAcceptanceBoard)[1]}</Link>
                </Menu.Item>
              )}
              {/* 모든 유저 Q&A 게시판 확인 가능하도록 */}
              {/* <Menu.Item key={ERoute.MentoringQNA}>
                <Link to={ERoute.MentoringQNA}>{getMenuTitle(ERoute.MentoringQNA)[1]}</Link>
              </Menu.Item> */}
              {/* 엑셀 강의 */}
            </SubMenu>

            {/* 📍 채용공고 */}
            {/* {currentUser.primary_field !== EMentoringField.Finance &&
              (currentUser.is_verified === true ? (
                <SubMenu title={companyMenuTitle(currentUser)}>*/}
            {/* 경력직 공고 */}
            {/*{currentUser.is_verified === true && currentUser?.user_type === EUserType.Mentor && (
                    <Menu.Item key={ERoute.CompanyTurnOver}>
                      <Link to={ERoute.CompanyTurnOver}>{getMenuTitle(ERoute.CompanyTurnOver)[1]}</Link>
                    </Menu.Item>
                  )}
                  {/* 정규직 공고 */}
            {/*<Menu.Item key={ERoute.CompanyFulltime}>
                    <Link to={ERoute.CompanyFulltime}>{getMenuTitle(ERoute.CompanyFulltime)[1]}</Link>
                  </Menu.Item> */}
            {/* 인턴공고 */}
            {/*<Menu.Item key={ERoute.CompanyParttime}>
                    <Link to={ERoute.CompanyParttime}>{getMenuTitle(ERoute.CompanyParttime)[1]}</Link>
                  </Menu.Item>
                  {/* 채용공고 등록(멘토만) */}
            {/*{currentUser?.user_type === EUserType.Mentor && currentUser?.userid === 'admin@admin.com' && (
                    <Menu.Item key={ERoute.CompanyJobOpening}>
                      <Link to={ERoute.CompanyJobOpening}>{getMenuTitle(ERoute.CompanyJobOpening)[1]}</Link>
                    </Menu.Item>
                  )}
                  {/* 회사 탐색 --> 채용공고에서 CSlab 탭으로 이동 */}
            {/* {currentUser.primary_field === EMentoringField.Consulting && (
                <Menu.Item key={ERoute.CompanySearch}>
                  <Link to={ERoute.CompanySearch}>
                    {getMenuTitle(ERoute.CompanySearch)[1]}
                  </Link>
                </Menu.Item>
              )} */}
            {/*</SubMenu>*/}
            {/*) : (
                <SubMenu
                  title={
                    <Tooltip
                      title={
                        <>
                          <div>전/현직 인증 필요</div>
                          <div>
                            <Link style={{ color: '#fff' }} to={ERoute.MentorVerification}>
                              재인증 요청하기
                            </Link>
                          </div>
                        </>
                      }
                    >
                      <span style={{ color: '#aeaeae' }}>{getMenuTitle('/company')[0]}</span>
                    </Tooltip>
                  }
                ></SubMenu>
              ))}*/}

            {/* 📍 CS컨텐츠 */}
            {/* {currentUser.primary_field !== EMentoringField.Finance && (
              <SubMenu title={CSLabMenuTitle()}>  */}
            {/* 엑셀 강의 */}
            {/* <Menu.Item key={ERoute.ExcelClassList}>
                  <Link to={ERoute.ExcelClassList}>{getMenuTitle(ERoute.ExcelClassList)[1]}</Link>
                </Menu.Item>*/}
            {/* CS 기획 Content-> CS 뉴스 - 멘토 멘티 공통 */}
            {/*<Menu.Item key={ERoute.CSLabBoard}>
                  <Link to={ERoute.CSLabBoard}>{getMenuTitle(ERoute.CSLabBoard)[1]}</Link>
                </Menu.Item>*/}
            {/* CS Webinar - 멘토 멘티 공통 */}
            {/*  <Menu.Item key={ERoute.CSWebinar}>
                  <Link to={ERoute.CSWebinar}>{getMenuTitle(ERoute.CSWebinar)[1]}</Link>
                </Menu.Item>*/}
            {/* 회사 탐색 - 멘토 멘티 공통 */}
            {/* <Menu.Item key={ERoute.CompanySearch}>
                  <Link to={ERoute.CompanySearch}>{getMenuTitle(ERoute.CompanySearch)[1]}</Link>
                </Menu.Item>*/}
            {/* 멘토 Finder - 멘토 멘티 공통 */}
            {/* <Menu.Item key={ERoute.CSLabMentorFinder}>
              <Link to={ERoute.CSLabMentorFinder}>
                {getMenuTitle(ERoute.CSLabMentorFinder)[1]}
              </Link>
            </Menu.Item> */}
            {/* 멘토 전환하기 - 멘티만 */}
            {/* {currentUser?.user_type === EUserType.Mentee && (
              <Menu.Item key={ERoute.CSLabSwitchToMentor}>
                <Link to={ERoute.CSLabSwitchToMentor}>
                  {getMenuTitle(ERoute.CSLabSwitchToMentor)[1]}
                </Link>
              </Menu.Item>
            )} */}
            {/* My Intern Finder - 멘토만 */}
            {/* {currentUser.is_verified === true &&
              currentUser?.user_type === EUserType.Mentor && (
                <Menu.Item key={ERoute.CompanyInternFinder}>
                  <Link to={ERoute.CompanyInternFinder}>
                    {getMenuTitle(ERoute.CompanyInternFinder)[1]}
                  </Link>
                </Menu.Item>
              )} */}
            {/* </SubMenu> */}
            {/* )}*/}
            {/* 📍 문의하기 */}
            {/* <Menu.Item key={ERoute.IntroductionCustomerInquiry}>
              <Link to={ERoute.IntroductionCustomerInquiry}>
                {getMenuTitle(ERoute.IntroductionCustomerInquiry)[1]}
              </Link>
            </Menu.Item> */}
            <SubMenu title={introductionMenuTitle()}>
              {/* <Menu.Item key={ERoute.IntroductionCustomerInquiry}>
                <Link to={ERoute.IntroductionCustomerInquiry}>
                  {getMenuTitle(ERoute.IntroductionCustomerInquiry)[1]}
                </Link>
              </Menu.Item> */}
              {/* <Menu.Item key={CNotionFAQURL}>
                <a target='_blank' rel='noopener noreferrer' href={CNotionFAQURL}>
                  FAQ
                </a>
              </Menu.Item> */}
            </SubMenu>

            {/* 커리어스텝 러닝 */}
            {/* {(currentUser?.userid === 'admin@admin.com' ||
            currentUser?.userid === 'test@naver.com') && (
            <SubMenu title={learningMenuTitle(currentUser)}>
              <Menu.Item key={ERoute.CSLearningBoard}>
                <Link to={ERoute.CSLearningBoard}>
                  {getMenuTitle(ERoute.CSLearningBoard)[1]}
                </Link>
              </Menu.Item>
              <Menu.Item key={ERoute.CSLearningQuizList}>
                <Link to={ERoute.CSLearningQuizList}>
                  {getMenuTitle(ERoute.CSLearningQuizList)[1]}
                </Link>
              </Menu.Item>
            </SubMenu>
          )} */}
          </Menu>

          {/* <SNSLinkedIconGroup /> */}
          <StyledSNSIcon>
            <a className='instagram' href={CInstagramURL} target='_blank' rel='noopener noreferrer'>
              <InstagramSource fill={Colors.grey2} width='20px' height='20px' />
            </a>
            <a href={CKakaoTalkURL} target='_blank' rel='noopener noreferrer'>
              <KakaoSource fill={Colors.grey2} width='25px' height='25px' />
            </a>
            <a href={CYoutubeURL} target='_blank' rel='noopener noreferrer'>
              <YoutubeSVGSource fill={Colors.grey2} width='25px' height='25px' />
            </a>
          </StyledSNSIcon>
        </StyledMenubarWrapper>
      ) : (
        <StyledMenubarWrapper>
          <Menu
            //햄버거 메뉴일 때는 mode가 inline인데 이 때는 height 70px 먹지 않도록
            style={{
              height: `${mode !== 'inline' && HeaderHeight}px`,
              width: `${mode !== 'inline' ? '80%' : '100%'}`,
            }}
            selectedKeys={[location.pathname]}
            mode={mode}
            onClick={onClick}
          >
            <SubMenu
              title={
                <Link to={`${ERoute.MentoringProgramAbout}?field=${EMentoringField.Consulting}`}>
                  <div className='submenu-title'>프로그램 소개</div>
                </Link>
              }
            >
              <Menu.Item key={`${ERoute.MentoringProgramAbout}?field=${EMentoringField.Consulting}`}>
                <Link to={`${ERoute.MentoringProgramAbout}?field=${EMentoringField.Consulting}`}>
                  Consulting
                </Link>
              </Menu.Item>
              {/*<Menu.Item key={`${ERoute.MentoringProgramAbout}?field=${EMentoringField.Finance}`}>
                <Link to={`${ERoute.MentoringProgramAbout}?field=${EMentoringField.Finance}`}>Finance</Link>
              </Menu.Item>*/}
              {/* <Menu.Item
              key={`${ERoute.MentoringProgramAbout}?field=${EMentoringField.Tech}`}
            >
              <Link
                to={`${ERoute.MentoringProgramAbout}?field=${EMentoringField.Tech}`}
              >
                Tech
              </Link>
            </Menu.Item> */}
              {/* <Menu.Item key={ERoute.CaseIntroduction}>
              <Link to={ERoute.CaseIntroduction}>
                {getMenuTitle(ERoute.CaseIntroduction)[1]}
              </Link>
            </Menu.Item> */}
            </SubMenu>
            {/* 📍 케이스 스터디 */}
            {/* {currentUser.primary_field === 'consulting' && ( */}
            <SubMenu title={caseMenuTitle()}>
              {/* framework */}
              <Menu.Item key={ERoute.CSLearningBoard}>
                <Link to={ERoute.CSLearningBoard}>{getMenuTitle(ERoute.CSLearningBoard)[1]}</Link>
              </Menu.Item>

              <Menu.Item key={ERoute.CSLearningBoard}>
                <Link to={ERoute.LectureInterviewMasterClassBasic}>기초편 온라인 강의</Link>
              </Menu.Item>

              {/* quizzes */}
              <Menu.Item key={ERoute.CSLearningQuizList}>
                <Link to={ERoute.CSLearningQuizList}>{getMenuTitle(ERoute.CSLearningQuizList)[1]}</Link>
              </Menu.Item>

              {/* 케이스 노트 소개 */}
              <Menu.Item key={ERoute.CaseIntroduction}>
                <Link to={ERoute.CaseIntroduction}>{getMenuTitle(ERoute.CaseIntroduction)[1]}</Link>
              </Menu.Item>

              <Menu.Item key={ERoute.ExcelClassList}>
                <Link to={ERoute.ExcelClassList}>{getMenuTitle(ERoute.ExcelClassList)[1]}</Link>
              </Menu.Item>

              {/* 케이스 노트 리스트 페이지 */}
              {/* <Menu.Item key={ERoute.CaseBoard}>
                <Link to={ERoute.CaseBoard}>
                  {getMenuTitle(ERoute.CaseBoard)[1]}
                </Link>
              </Menu.Item> */}
              {/* {(currentUser?.userid === 'admin@admin.com' ||
                currentUser?.userid === 'test@naver.com') && ( //케이스 라이브러리
                <Menu.Item key={ERoute.CaseLibrary}>
                  <Link to={ERoute.CaseLibrary}>
                    {getMenuTitle(ERoute.CaseLibrary)[1]}
                  </Link>
                </Menu.Item>
              )} */}
            </SubMenu>
            {/* )} */}

            {/* <Menu.Item key={ERoute.CSLabBoard}>
            <Link to={ERoute.CSLabBoard}>
              {getMenuTitle(ERoute.CSLabBoard)[1]}
            </Link>
          </Menu.Item> */}
            {/* 공지사항 -> cs 뉴스로 통합 */}
            {/* <Menu.Item key={ERoute.IntroductionAnnouncement}>
            <Link to={ERoute.IntroductionAnnouncement}>
              {getMenuTitle(ERoute.IntroductionAnnouncement)[1]}
            </Link>
          </Menu.Item> */}
            {/* 📍 1:1 멘토링 */}
            {/* 500에러 뜨는건 아마 백엔드에서 막아놔서?? */}
            <SubMenu title={mentoringMenuTitle()}>
              <Menu.Item key={ERoute.MentoringMentorList}>
                <Link to={ERoute.MentoringMentorList}>{getMenuTitle(ERoute.MentoringMentorList)[1]}</Link>
              </Menu.Item>
            </SubMenu>
            {/* 📍 커뮤니티 */}
            <SubMenu title={CSLabMenuTitle()}>
              {/* 인터뷰 후기 */}
              <Menu.Item key={ERoute.InterviewReviewBoard}>
                <Link to={ERoute.InterviewReviewBoard}>{getMenuTitle(ERoute.InterviewReviewBoard)[1]}</Link>
              </Menu.Item>
              {/* 최종 합격 후기 */}
              <Menu.Item key={ERoute.FinalAcceptanceBoard}>
                <Link to={ERoute.FinalAcceptanceBoard}>{getMenuTitle(ERoute.FinalAcceptanceBoard)[1]}</Link>
              </Menu.Item>
            </SubMenu>

            {/* 📍 채용공고 */}
            {/*<SubMenu title={companyMenuTitle()}>*/}
            {/* 정규직 공고 */}
            {/* <Menu.Item key={ERoute.CompanyFulltime}>
                <Link to={ERoute.CompanyFulltime}>{getMenuTitle(ERoute.CompanyFulltime)[1]}</Link>
              </Menu.Item> */}
            {/* 인턴공고 */}
            {/*<Menu.Item key={ERoute.CompanyParttime}>
                <Link to={ERoute.CompanyParttime}>{getMenuTitle(ERoute.CompanyParttime)[1]}</Link>
              </Menu.Item>*/}
            {/* 채용공고 등록(멘토만) */}
            {/* {currentUser?.user_type === EUserType.Mentor &&
              currentUser?.userid === 'admin@admin.com' && (
                <Menu.Item key={ERoute.CompanyJobOpening}>
                  <Link to={ERoute.CompanyJobOpening}>
                    {getMenuTitle(ERoute.CompanyJobOpening)[1]}
                  </Link>
                </Menu.Item>
              )} */}
            {/*</SubMenu>*/}
            {/* 📍 CS컨텐츠 */}
            {/* <SubMenu title={CSLabMenuTitle()}> */}
            {/* <Menu.Item key={'유튜브'}>
              <a
                href="https://www.youtube.com/channel/UCgkAO-a21gnukng0vTZefhw"
                target="_blank"
                rel="noopener noreferrer"
              >
                {'유튜브'}
              </a>
            </Menu.Item>
            <Menu.Item key={'블로그'}>
              <a
                href="https://www.temble.com/careerstep"
                target="_blank"
                rel="noopener noreferrer"
              >
                {'블로그'}
              </a>
            </Menu.Item>
            <Menu.Item key={'인스타그램'}>
              <a
                href="https://www.instagram.com/bigstepedu"
                target="_blank"
                rel="noopener noreferrer"
              >
                {'인스타그램'}
              </a>
            </Menu.Item> */}
            {/* 엑셀 강의 */}
            {/*<Menu.Item key={ERoute.ExcelClassList}>
                <Link to={ERoute.ExcelClassList}>{getMenuTitle(ERoute.ExcelClassList)[1]}</Link>
              </Menu.Item>*/}
            {/* CS 뉴스 */}
            {/*<Menu.Item key={ERoute.CSLabBoard}>
                <Link to={ERoute.CSLabBoard}>{getMenuTitle(ERoute.CSLabBoard)[1]}</Link>
              </Menu.Item>*/}
            {/* CS 웨비나 */}
            {/*<Menu.Item key={ERoute.CSWebinar}>
                <Link to={ERoute.CSWebinar}>{getMenuTitle(ERoute.CSWebinar)[1]}</Link>
              </Menu.Item>*/}
            {/* 회사 탐색  */}
            {/*<Menu.Item key={ERoute.CompanySearch}>
                <Link to={ERoute.CompanySearch}>{getMenuTitle(ERoute.CompanySearch)[1]}</Link>
              </Menu.Item>*/}
            {/* CS 뉴스*/}
            {/* <Menu.Item key={ERoute.CSLabBoard}>
              <Link to={ERoute.CSLabBoard}>
                {getMenuTitle(ERoute.CSLabBoard)[1]}
              </Link>
            </Menu.Item> */}
            {/*</SubMenu>*/}
            {/* 📍 문의하기 */}
            {/* <Menu.Item key={ERoute.IntroductionCustomerInquiry}>
              <Link to={ERoute.IntroductionCustomerInquiry}>
                {getMenuTitle(ERoute.IntroductionCustomerInquiry)[1]}
              </Link>
            </Menu.Item> */}
            <SubMenu title={introductionMenuTitle()}>
              {/* <Menu.Item key={ERoute.IntroductionCustomerInquiry}>
                <Link to={ERoute.IntroductionCustomerInquiry}>
                  {getMenuTitle(ERoute.IntroductionCustomerInquiry)[1]}
                </Link>
              </Menu.Item> */}
              {/* <Menu.Item key={CNotionFAQURL}>
                <a target='_blank' rel='noopener noreferrer' href={CNotionFAQURL}>
                  FAQ
                </a>
              </Menu.Item> */}
            </SubMenu>
          </Menu>
          {/* <SNSLinkedIconGroup /> */}
          <StyledSNSIcon>
            <a className='instagram' href={CInstagramURL} target='_blank' rel='noopener noreferrer'>
              <InstagramSource fill={Colors.grey2} width='20px' height='20px' />
            </a>
            <a href={CInstagramURL} target='_blank' rel='noopener noreferrer'>
              <KakaoSource fill={Colors.grey2} width='25px' height='25px' />
            </a>
            <a href={CYoutubeURL} target='_blank' rel='noopener noreferrer'>
              <YoutubeSVGSource fill={Colors.grey2} width='26px' height='26px' />
            </a>
          </StyledSNSIcon>
        </StyledMenubarWrapper>
      )}
    </HeaderLeftWrapper>
  );
};

const HeaderLeftWrapper = styled.div`
  .small-logo {
    opacity: 0.3;
    .ant-avatar-square {
      width: 18px;
      height: 18px;
    }
    .ant-menu-horizontal > .ant-menu-item a {
      color: red !important;
    }
    .ant-menu-submenu .submenu-title {
      height: 100%;
      color: red;
    }
  }
`;

const StyledSNSIcon = styled.div`
  display: flex;
  align-items: center;

  a {
    display: flex;
    align-items: center;
    padding: 0 7px;
  }

  @media screen and ${device.xl} {
    margin-top: 10px;
  }
`;

const StyledMenubarWrapper = styled.div`
  display: flex;
  align-items: center;
  height: ${HeaderHeight}px;
  @media screen and (max-width: ${menubarBreakPoint}px) {
    flex-direction: column;
  }
`;
